import React from "react";
import { useAppContext } from "./appContext";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   selectError,
//   selectIsLoading,
// } from "./pages/homeSlice";
import { HashRouter, Routes, Route, BrowserRouter, Switch, Navigate, RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import HideOnScroll from "./components/HideOnScroll";
import Loading from "./components/Loading";
import ReviewSettingAdditionalCommentSetting from "./pages/review/ReviewSettingAdditionalCommentSetting";
// Pages
import Home from "./pages/home/Home";
import Review from "./pages/review/Review";
import BottomNav from "./components/BottomNav";
import { useDispatch } from "react-redux";
import { fetchCeo } from "./slice/sliceCeo";
import EditReview from "./pages/review/EditReview";
import ReviewSettingAdditionalComment from "./pages/review/ReviewSettingAdditionalComment";
import { ReviewSettingPopupAdditionalCommentAddSuccess } from "./pages/review/ReviewPopup";
import PremiumIntro from "./pages/premiumIntro/PremiumIntro";
import { anonymousRouters, appRoutes } from "./routing";
import RouteLayout from "./components/layouts/RouteLayout";
import { ROUTE_PATHS } from "./constants/Router";
import AnonymousLayout from "./components/layouts/AnonymousLayout";
import { AuthProvider } from "./contexts/JWTContext";
import useNetworkStatus from "./hooks/useNetworkStatus";
import NetworkOfflineIssue from "./pages/error/NetworkOfflineIssue";
import { ErrorBoundary } from "react-error-boundary";
import Error from "./pages/error/Error";


const darkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
const themes = {
  light: {
    name: "light",
    // color: "#45413C",
    // color: "#252729",
    color: "#000000",
    background: "#F5F2E8",
  },
  dark: {
    name: "dark",
    color: "#FBFDFF",
    background: "#27272A",
  },
};

export default function App() {
  const { theme, setTheme } = useAppContext();
  const { isOnline } = useNetworkStatus();
  // const isLoading = useSelector(selectIsLoading);
  // const error = useSelector(selectError);
  // const dispatch = useDispatch();

  // React.useEffect(
  //   function () {
  //     const updateTheme = () =>
  //       darkMode ? setTheme("dark") : setTheme("light");
  //     updateTheme();
  //   },
  //   [setTheme, dispatch]
  // );

  // const dispatch = useDispatch();
  // React.useEffect(function () {
  //   dispatch(fetchCeo());
  // }, []);

  React.useEffect(
    function () {
      const updateTheme = () =>
        darkMode ? setTheme("dark") : setTheme("light");
      updateTheme();
    },
    [setTheme]
  );
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", (e) =>
      e.matches ? setTheme("dark") : setTheme("light")
    );

  return (
    <>{isOnline ?
      <ErrorBoundary FallbackComponent={Error}>
        <HashRouter>
          <ThemeProvider theme={themes[theme]}>
            {/* <ScrollToTop /> */}
            {/* <GlobalStyles /> */}
            {/* <Element name={"Home"} id="home">
            <NavBar Logo={navLogo} />
          </Element> */}
            {/* <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/review/*" element={<Review />} />
          <Route path="/edit-review/*" element={<EditReview />} />
          <Route path="/review-additional-comment/*" element={<ReviewSettingAdditionalCommentSetting />} />
          <Route path="/premium-intro" element={<PremiumIntro />} />
        </Routes> */}

            <AuthProvider>
              <Routes>
                {appRoutes.map(({ href, component, loginRequired, hideLogoHeader, hideFooter }, index) => (
                  <Route
                    key={index}
                    path={href}
                    element={<RouteLayout element={component} loginRequired={loginRequired} hideLogoHeader={hideLogoHeader} hideFooter={hideFooter} />}
                  />
                ))}
              </Routes>
            </AuthProvider>
          </ThemeProvider>
        </HashRouter>
      </ErrorBoundary>
      : <NetworkOfflineIssue />
    }
    </>

  );

  // if (isLoading) {
  //   return (
  //     <ThemeProvider theme={themes[theme]}>
  //       {/* <GlobalStyles /> */}
  //       <div>
  //         <Loading />
  //       </div>
  //     </ThemeProvider>
  //   );
  // } else if (error) {
  //   return (
  //     <ThemeProvider theme={themes[theme]}>
  //       {/* <GlobalStyles /> */}
  //       <div>
  //         <h2>{error}</h2>
  //       </div>
  //     </ThemeProvider>
  //   );
  // } else {
  //   return (
  //     <HashRouter>
  //       <ThemeProvider theme={themes[theme]}>
  //         {/* <ScrollToTop /> */}
  //         {/* <GlobalStyles /> */}
  //         {/* <Element name={"Home"} id="home">
  //           <NavBar Logo={navLogo} />
  //         </Element> */}
  //         <Routes>
  //           <Route exact path="/" element={<Home />} />
  //           {/* <Route path="/All-Projects" element={<AllProjects />} />
  //           <Route path="*" element={<NotFound />} /> */}
  //         </Routes>
  //       </ThemeProvider>
  //     </HashRouter>
  //   );
  // }
}
